var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import srciLogicSdk from "@payair/srci-logic-sdk";
import { ResultStatusObj } from "@payair/srci-logic-sdk/models/ResultStatus";
import { SrciEventTypeEnumsObj } from "../../enums/SrciEventTypeEnum";
import { buildDcfErrorsTelemetry, buildDcfTelemetry, buildReasonTelemetry, buildUnexpectedExceptionTelemetry, } from "./SrciTelemetry";
/** Owns identity and OTP operation telemetry without leaking credentials into events. */
var SrciIdentityLifecycle = /** @class */ (function () {
    function SrciIdentityLifecycle(eventReporter) {
        var _this = this;
        this.eventReporter = eventReporter;
        this.sendEvent = function (eventType, payload) {
            var _a, _b;
            if (payload === undefined)
                (_a = _this.eventReporter) === null || _a === void 0 ? void 0 : _a.sendEvent(eventType);
            else
                (_b = _this.eventReporter) === null || _b === void 0 ? void 0 : _b.sendEvent(eventType, payload);
        };
        this.run = function (config) { return __awaiter(_this, void 0, void 0, function () {
            var result, error_1, outcome;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sendEvent(config.startedEvent, config.startedPayload);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, config.execute()];
                    case 2:
                        result = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.sendEvent(config.errorEvent, buildUnexpectedExceptionTelemetry(config.errorContext, error_1));
                        throw error_1;
                    case 4:
                        try {
                            outcome = config.classify(result);
                        }
                        catch (error) {
                            this.sendEvent(config.errorEvent, buildUnexpectedExceptionTelemetry(config.errorContext, error));
                            throw error;
                        }
                        this.sendEvent(outcome.eventType, outcome.payload);
                        if (outcome.error)
                            throw outcome.error;
                        return [2 /*return*/, result];
                }
            });
        }); };
        this.classifyDcfResponse = function (params) {
            var response = params.response, successEvent = params.successEvent, errorEvent = params.errorEvent, lifecyclePayload = params.lifecyclePayload, errorContext = params.errorContext;
            if (!response ||
                (response.status !== ResultStatusObj.FULFILLED && response.status !== ResultStatusObj.REJECTED)) {
                return {
                    eventType: errorEvent,
                    payload: buildReasonTelemetry("INVALID_RESPONSE", errorContext),
                    error: new Error(params.invalidResponseMessage),
                };
            }
            if (response.status !== ResultStatusObj.FULFILLED) {
                return { eventType: errorEvent, payload: buildDcfTelemetry(response, errorContext) };
            }
            if (!params.hasRequiredValue(response.value)) {
                return {
                    eventType: errorEvent,
                    payload: buildReasonTelemetry("INVALID_RESPONSE", errorContext),
                };
            }
            return { eventType: successEvent, payload: lifecyclePayload };
        };
        this.identityLookup = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var context;
            return __generator(this, function (_a) {
                context = {};
                return [2 /*return*/, this.run({
                        startedEvent: SrciEventTypeEnumsObj.IDENTITY_LOOKUP_STARTED,
                        errorEvent: SrciEventTypeEnumsObj.IDENTITY_LOOKUP_ERROR,
                        errorContext: context,
                        execute: function () { return srciLogicSdk.identityLookup(params); },
                        classify: function (responses) {
                            if (!Array.isArray(responses) || responses.length === 0) {
                                return {
                                    eventType: SrciEventTypeEnumsObj.IDENTITY_LOOKUP_ERROR,
                                    payload: buildReasonTelemetry("INVALID_RESPONSE", context),
                                };
                            }
                            var invalidResponses = responses.filter(function (response) {
                                var _a;
                                return response.status !== ResultStatusObj.FULFILLED ||
                                    typeof ((_a = response.value) === null || _a === void 0 ? void 0 : _a.consumerPresent) !== "boolean";
                            });
                            if (invalidResponses.length > 0) {
                                var telemetryErrors = invalidResponses.map(function (response) {
                                    return response.status === ResultStatusObj.FULFILLED
                                        ? { sdk: response.sdk, reason: { reason: "INVALID_RESPONSE" } }
                                        : response;
                                });
                                return {
                                    eventType: SrciEventTypeEnumsObj.IDENTITY_LOOKUP_ERROR,
                                    payload: buildDcfErrorsTelemetry(telemetryErrors, context),
                                };
                            }
                            return { eventType: SrciEventTypeEnumsObj.IDENTITY_LOOKUP_SUCCESS };
                        },
                    })];
            });
        }); };
        this.sendOtp = function (validationChannelId, network, operation) { return __awaiter(_this, void 0, void 0, function () {
            var lifecyclePayload, errorContext;
            var _this = this;
            return __generator(this, function (_a) {
                lifecyclePayload = __assign({ operation: operation }, (network ? { network: network } : {}));
                errorContext = { operation: operation, network: network };
                return [2 /*return*/, this.run({
                        startedEvent: SrciEventTypeEnumsObj.OTP_SEND_STARTED,
                        errorEvent: SrciEventTypeEnumsObj.OTP_SEND_ERROR,
                        startedPayload: lifecyclePayload,
                        errorContext: errorContext,
                        execute: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, srciLogicSdk.initiateIdentityValidation(validationChannelId, network)];
                                case 1: return [2 /*return*/, (_a.sent())[0]];
                            }
                        }); }); },
                        classify: function (response) {
                            return _this.classifyDcfResponse({
                                response: response,
                                successEvent: SrciEventTypeEnumsObj.OTP_SEND_SUCCESS,
                                errorEvent: SrciEventTypeEnumsObj.OTP_SEND_ERROR,
                                lifecyclePayload: lifecyclePayload,
                                errorContext: errorContext,
                                hasRequiredValue: function (value) { return Boolean(value === null || value === void 0 ? void 0 : value.maskedValidationChannel); },
                                invalidResponseMessage: "Invalid OTP send response.",
                            });
                        },
                    })];
            });
        }); };
        this.validateOtp = function (otp, network) { return __awaiter(_this, void 0, void 0, function () {
            var lifecyclePayload, errorContext;
            var _this = this;
            return __generator(this, function (_a) {
                lifecyclePayload = network ? { network: network } : {};
                errorContext = { network: network };
                return [2 /*return*/, this.run({
                        startedEvent: SrciEventTypeEnumsObj.OTP_VALIDATION_STARTED,
                        errorEvent: SrciEventTypeEnumsObj.OTP_VALIDATION_ERROR,
                        startedPayload: lifecyclePayload,
                        errorContext: errorContext,
                        execute: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, srciLogicSdk.completeIdentityValidation(otp, network)];
                                case 1: return [2 /*return*/, (_a.sent())[0]];
                            }
                        }); }); },
                        classify: function (response) {
                            return _this.classifyDcfResponse({
                                response: response,
                                successEvent: SrciEventTypeEnumsObj.OTP_VALIDATION_SUCCESS,
                                errorEvent: SrciEventTypeEnumsObj.OTP_VALIDATION_ERROR,
                                lifecyclePayload: lifecyclePayload,
                                errorContext: errorContext,
                                hasRequiredValue: function (value) { return Boolean(value === null || value === void 0 ? void 0 : value.idToken); },
                                invalidResponseMessage: "Invalid OTP validation response.",
                            });
                        },
                    })];
            });
        }); };
    }
    return SrciIdentityLifecycle;
}());
export { SrciIdentityLifecycle };
